import {
  Alert,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { getlocalStorageLogin } from "common/components/apiConfig";
import { handleNumber } from "common/method/displayData";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import moment from "jalali-moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { actionTypes as actionNotifycation } from "redux/notificationAlert/index";
import { activate_t0_payment } from "redux/payments/activate_t0_payment";
import { actionTypes } from "redux/payments/select_payment_requests_limits";
import { actionTypes as actionTypesT0 } from "redux/payments/select_t0_limits";
import { send_payment_request } from "redux/payments/send_payment_request";
import { send_t0_payment_request } from "redux/payments/send_t0_payment_request";
import WithdrawalCard from "./withdrawal";
import AnimatedBox from "common/animations";

let useStyles = makeStyles((theme) => ({
  modal: {
    width: "100%",
    backgroundColor: "white",
    padding: 20,
    minHeight: "80vh",
    marginTop: 20,
  },
  container: {
    width: "98%",
    margin: "auto",
  },
  modal_alert: {
    display: "flex",
    minHeight: 200,
    backgroundColor: "#ffffff",
    zIndex: 100,

    borderRadius: 5,

    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-45%, -50%)",
    bgcolor: "background.paper",
    outline: 0,
    border: 0,
    boxShadow: 24,
  },
}));

export default function Index() {
  let classes = useStyles();
  let dispatch = useDispatch();
  const [BankAccounts, setBankAccounts] = useState([]);
  const [PardakhtDays, setPardakhtDays] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [bankAccountId, setBankAccountId] = useState(0);

  const [IndexDate, setIndexDate] = useState({ time: "", cost: 0 });
  const [price, setPrice] = useState(IndexDate.cost);
  const [priceT0, setPriceT0] = useState("");
  const [sheba, setSheba] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingSheba, setLoadingSheba] = useState(false);
  const [flagApi, setflagApi] = useState(false);
  useEffect(() => {
    if (PardakhtDays.length > 0) {
      setIndexDate({
        time: moment(PardakhtDays[0].Date).format("jYYYY/jMM/jDD"),
        cost: PardakhtDays[0].Value,
      });
    }
  }, [PardakhtDays?.length > 0]);
  let reducer = useSelector(
    (state) => state.selectPaymentRequestsLimitsReducer,
  );
  const removeSeparator = (value) => {
    return value?.replace(/,/g, "");
  };
  let reducerTo = useSelector((state) => state.selectT0LimitsReducer);
  const toList = reducerTo?.data?.data?.results;
  useEffect(() => {
    setPrice(IndexDate.cost);
  }, [IndexDate]);
  useEffect(() => {
    if (reducer?.data?.length !== 0) {
      setBankAccounts(reducer?.data?.BankAccounts);
      setPardakhtDays(reducer?.data?.PardakhtDays);
    }
  }, [reducer?.data]);

  useEffect(() => {
    dispatch({ type: actionTypes.selectPaymentRequestsLimitsAsync });
  }, [flagApi]);
  useEffect(() => {
    dispatch({ type: actionTypesT0.selectT0LimitsAsync, payload: "" });
  }, []);
  useEffect(() => {
    setBankAccountId(BankAccounts?.[0]?.Id);
  }, [BankAccounts]);

  const handleChange = (event) => {
    const selectedValue = JSON.parse(event.target.value);
    setIndexDate(selectedValue);
  };

  const handleChangeBank = (event) => {
    setBankAccountId(parseInt(event.target.value));
  };

  const activeT0Handler = () => {
    if (!sheba) return;
    setLoadingSheba(true);

    let data = {
      iban: sheba,
    };

    activate_t0_payment(data)
      .then((res) => {
        // handleNotificationAlertTrySelect(res)
        if (res.data.response.is_successful) {
          dispatch({
            type: actionNotifycation.success,
            textAlert: "درخواست شما با موفقیت ثبت شد.",
          });
          setSheba("");
          setOpenModal(false);
        } else {
          handleNotificationAlertTrySelect(res);
        }
      })
      .catch(() => handleNotificationAlertCatch())
      .finally(() => {
        setLoadingSheba(false);
      });
  };

  const insertPayments = () => {
    if (!price) {
      dispatch({
        type: actionNotifycation.warning,
        textAlert: "لطفا مبلغ خود را وارد نمایید.",
      });
      return;
    }

    if (!IndexDate) {
      dispatch({
        type: actionNotifycation.warning,
        textAlert: "تاریخ مورد نظر یافت نشد.",
      });
      return;
    }

    if (!bankAccountId) {
      dispatch({
        type: actionNotifycation.warning,
        textAlert: "شماره حساب خود را وارد نمایید.",
      });
      return;
    }

    let data = {
      payment_request_date: IndexDate?.time,
      customer_bank_account_id: bankAccountId,
      request_amount: Number(removeSeparator(price)),
    };

    setLoading(true);
    send_payment_request(data)
      .then((res) => {
        // handleNotificationAlertTrySelect(res)
        if (res.data.response.is_successful) {
          dispatch({
            type: actionNotifycation.success,
            textAlert: "درخواست شما با موفقیت ثبت شد.",
          });
          setPrice("");
          setflagApi((prev) => !prev);
        } else {
          handleNotificationAlertTrySelect(res);
        }
      })
      .catch(() => handleNotificationAlertCatch())
      .finally(() => {
        setLoading(false);
      });
  };
  const formatSeperatorValue = (value) => {
    if (!value) {
      setPrice("");
      return;
    }

    const rawValue = value.replace(/[^0-9.]/g, "");
    const parts = rawValue.split(".");
    const integerPart = parts[0];
    const decimalPart = parts.length > 1 ? `.${parts[1]}` : "";

    const formattedValue =
      integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + decimalPart;
    setPrice(formattedValue);
  };
  const paymentRequestT0 = () => {
    const limitedPrice = toList?.map(
      (item, index) => item?.body?.paymentRequestLimit,
    );
    if (priceT0 > limitedPrice?.[0]) {
      return toast.error("مبلغ وارد شده بیش از مقدار قابل برداشت است!");
    }

    let data = {
      request_amount: +priceT0,
    };

    send_t0_payment_request(data)
      .then((res) => {
        // handleNotificationAlertTrySelect(res)
        if (res.data.response.is_successful) {
          dispatch({
            type: actionNotifycation.success,
            textAlert: "درخواست شما با موفقیت ثبت شد.",
          });
          setPrice("");
          setflagApi((prev) => !prev);
        } else {
          handleNotificationAlertTrySelect(res);
        }
      })
      .catch(() => handleNotificationAlertCatch())
      .finally(() => {
        setLoading(false);
      });
  };

  const [shebaError, setShebaError] = useState(false);

  useEffect(() => {
    if (!sheba) {
      return setShebaError(false);
    }
    if (/^(?:IR)(?=.{24}$)[0-9]*$/.test(sheba)) {
      setShebaError(false);
    } else {
      setShebaError(true);
    }
  }, [sheba]);

  const hasPermissionsList = [
    "0016094530",
    "0532417763",
    "2560071721",
    "1292380391",
    "0019192967",
    "0015761843",
    "0022893938",
    "1450965164",
  ];
  const [hasPermissions, setHasPermission] = useState();
  const permission = (nationalIdList) => {
    const adminObj = getlocalStorageLogin();

    // const adminData = JSON?.parse(localStorage?.getItem("admin"));
    const user = adminObj?.user;
    const nationalId = user?.member_national_id;

    const havePermission = nationalIdList.includes(nationalId);
    return havePermission;
  };
  useEffect(() => {
    const permission = (nationalIdList) => {
      const adminObj = getlocalStorageLogin();

      // const adminData = JSON?.parse(localStorage?.getItem("admin"));
      const user = adminObj?.user;
      const nationalId = user?.member_national_id;

      const havePermission = nationalIdList.includes(nationalId);
      return havePermission;
    };

    setHasPermission(permission(hasPermissionsList));
  }, []);

  if (reducerTo?.loading) {
    return (
      <div className="w-100 text-center">
        <CircularProgress />
      </div>
    );
  }
  const asadi = [
    "0016094530",
    "0083402691",
    "0022893938",
    "1672374677",
    "0081741588",
    "0015761843",
    "0019192967",
    "2560071721",
    "1450965164",
  ];

  return (
    <div className={classes["modal"]}>
      <div className={classes["container"]}>
        <div>
          <h1 className={`${classes["title"]} text-lg text-gray-600`}>
            تقاضای وجه
          </h1>
          <hr className="mt-3 mb-3" />
        </div>
        <AnimatedBox>
          <Alert severity="warning" sx={{ mb: 3 }}>
            <p className="font-bold">
              کاربر گرامی متاسفانه به دلیل اختلالات بانکی تراکنش بانک های تجارت
              ، ملی ، صادرات و توسعه صادرات با اختلال رو به رو هستند .
            </p>
          </Alert>

          <div className={"flex justify-between align-center flex-wrap  mt-3"}>
            <Card
              style={{
                background: "linear-gradient(to right, #e5f4ff, #ffffff)",
                padding: "20px",
                borderRadius: "10px",
                gap: "24px",
              }}
              className=" w-[100%] md:w-[48%] min-w-[250px] md:min-w-[300px]  border p-5"
            >
              <Typography
                variant="h6"
                component="div"
                style={{
                  marginBottom: "20px",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              >
                درخواست برداشت عادی
              </Typography>
              <CardContent>
                <div className="w-full">
                  <div className=" flex items-center justify-between">
                    <p className=" font-bold text-sm">تاریخ پرداخت</p>
                    <p className=" font-bold text-sm">حداکثر مبلغ برداشت</p>
                  </div>
                  <div>
                    <FormControl className="w-full">
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group"
                        value={JSON.stringify(IndexDate)} // Stringify object for RadioGroup value
                        onChange={handleChange}
                      >
                        {PardakhtDays?.map((item) => (
                          <div
                            className={`${classes["cardDate"]} flex items-center justify-between w-full`}
                            key={item?.Date}
                          >
                            <div className="flex items-center">
                              <FormControlLabel
                                value={JSON.stringify({
                                  time: moment(item?.Date).format(
                                    "jYYYY/jMM/jDD",
                                  ),
                                  cost: item?.Value,
                                })} // Stringify object for Radio value
                                control={<Radio />}
                              />
                              <p className="p-0 m-0">
                                {moment(item?.Date).format("jYYYY/jMM/jDD")}
                              </p>
                            </div>
                            <p
                              className="text-right"
                              style={{ direction: "ltr" }}
                            >
                              {handleNumber(item?.Value)}
                            </p>
                          </div>
                        ))}
                      </RadioGroup>
                    </FormControl>

                    {reducer?.loading && (
                      <div className="w-full text-center mt-2">
                        <CircularProgress />
                      </div>
                    )}
                  </div>

                  <div>
                    <TextField
                      id="standard-select-currency"
                      value={price}
                      onChange={(event) =>
                        formatSeperatorValue(event.target.value)
                      }
                      size="small"
                      fullWidth
                      margin="dense"
                      label="مبلغ (ریال)"
                      variant="outlined"
                      type="text"
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div>
                    <div>
                      <FormControl className="w-full" size="small">
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          defaultValue=""
                          name="radio-buttons-group"
                          value={bankAccountId}
                          onChange={handleChangeBank}
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            flexWrap: "wrap",
                          }}
                        >
                          {BankAccounts?.map((item) => (
                            <div
                              className="flex items-center justify-start mt-2"
                              key={item.Id}
                            >
                              <FormControlLabel
                                value={item.Id.toString()}
                                control={<Radio />}
                                label={item.Description}
                              />
                            </div>
                          ))}
                        </RadioGroup>
                      </FormControl>
                      {reducer?.loading && (
                        <div className="w-full text-center">
                          <CircularProgress />
                        </div>
                      )}
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: 24,
                      marginBlockStart: 12,
                    }}
                  >
                    <Button
                      disabled={!price}
                      variant="contained"
                      color="primary"
                      size="large"
                      className="m-4 text-white w-full md:w-[150px]"
                      onClick={insertPayments}
                    >
                      ثبت درخواست
                    </Button>

                    <Button
                      variant="contained"
                      style={{ backgroundColor: "red" }}
                      size="large"
                      className="m-4 text-white w-full md:w-[150px]"
                    >
                      لغو
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
            {!hasPermissions || reducerTo?.data?.error_code === 135601 ? (
              <div className=" w-[100%] md:w-[48%] min-w-[250px] md:min-w-[300px] h-full   ">
                <div className="border">
                  {/* {!permission(asadi) ? (
                  <div style={{ padding: 24 }}>
                    <p className="mb-2 text-[red]">قابل توجه مشتریان محترم</p>
                    <p className="mb-2 text-xs">
                      در موارد زیر درخواست وجه پرداخت نخواهد شد
                    </p>
                    <p className="mb-2 text-xs">
                      نام صاحب حساب معرفی شده به نام شخص دیگری باشد
                    </p>
                    <p className="mb-2 text-xs">حساب مشترک باشد</p>
                    <p className="mb-2 text-xs">حساب مسدود یا راکد باشد</p>
                    <p className="mb-2 text-xs">
                      شماره حساب و شماره شبا دارای مغایرت باشند
                    </p>
                  </div>
                ) : (
                  <div>
                    <WithdrawalCard />
                  </div>
                )} */}
                  <div>
                    <WithdrawalCard />
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </AnimatedBox>
      </div>
      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className={classes["modal_alert"]}>
          <div className="w-full  h-full">
            <div className="p-6 gap-4">
              <p className="gap-4 leading-8">ثبت شماره شبا</p>
              <div className="mt-2 flex ">
                <TextField
                  style={{ minWidth: 250 }}
                  id="standard-select-currency"
                  label={"شماره شبا"}
                  value={sheba}
                  onChange={(event) => setSheba(event.target.value)}
                  helperText=""
                  size="medium"
                  fullWidth
                  variant="outlined"
                  margin="dense"
                  // onKeyDown={event => (event.keyCode === 13 ? handleSubmit() : "")}
                />
              </div>
              {shebaError ? (
                <div>
                  <p style={{ color: "red" }} color="red">
                    شماره شبا نادرست است!
                  </p>
                </div>
              ) : (
                <div>
                  <p style={{ color: "" }} color="">
                    مثال : IR212121212121212121212121{" "}
                  </p>
                </div>
              )}
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBlockEnd: 8,
              }}
            >
              <Button
                disabled={!sheba || shebaError || loadingSheba}
                style={{ marginInlineEnd: 16 }}
                variant="contained"
                color="primary"
                size="large"
                className="text-white md:max-w-[250px]  mt-8"
                onClick={() => {
                  if (!sheba || shebaError) return;

                  activeT0Handler();
                }}
              >
                ثبت{" "}
              </Button>
              <Button
                variant="contained"
                color="inherit"
                size="large"
                className="text-white md:max-w-[250px]  mt-8"
                onClick={() => {
                  setOpenModal(false);
                }}
              >
                انصراف{" "}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
